import React from 'react';
import { useTranslation } from 'react-i18next';
import { JournalAttendanceGauge } from '@/pages/Overview/JournalAttendanceGauge';
import { getPercent } from '@/utils/text';

interface Props {
  attendableLessonsCount: number;
  nonAttendancesCount: number;
}

export const JournalAttendanceCard: React.FC<Props> = ({
  attendableLessonsCount,
  nonAttendancesCount,
}) => {
  const { t } = useTranslation();
  const attended = attendableLessonsCount - nonAttendancesCount;

  return (
    <div className="flex items-center gap-5 rounded-xl bg-popover p-4 shadow-card contrast:border contrast:border-border">
      <JournalAttendanceGauge
        percent={getPercent(attended, attendableLessonsCount)}
      />
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="text-body-13 md:text-body-14 text-subtle-foreground">
          {t('overview.attendance.totalAttendance')}
        </p>
        <p className="text-callout-16 md:text-subhead-14 text-primary">
          {t('overview.attendance.attendedCount', {
            attended,
            total: attendableLessonsCount,
          })}
        </p>
      </div>
    </div>
  );
};
